// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"73a6ff3e93d18e4ddd68","245":"483444d9ad3712df9850","453":"ea26d8834adbc7c4671f"}[chunkId] + ".js";
};